<app-top-menu></app-top-menu>

<main class="taas-public-page">
  <section class="taas-hero">
    <div class="taas-container taas-hero__grid">
      <div class="taas-hero__copy">
        <h1>
          <span>Streamlining</span>
          <span>Professional Tax</span>
          <span>Practice In</span>
          <span>Anambra State.</span>
        </h1>
        <p>
          TAAS is the official digital accreditation and verification platform
          for tax practitioners operating in Anambra State. Apply, get certified,
          and let taxpayers verify your standing in seconds.
        </p>

        <div class="taas-actions">
          <button type="button" class="taas-button taas-button--dark" (click)="startApplication()">
            Apply for Accreditation
            <span class="material-icons">arrow_forward</span>
          </button>
          <button type="button" class="taas-button taas-button--light" (click)="scrollToVerification()">
            <span class="material-icons">search</span>
            Verify an Agent
          </button>
        </div>
      </div>

      <div class="taas-hero__visual" aria-hidden="true">
        <app-taas-hero-art></app-taas-hero-art>
      </div>
    </div>
  </section>

  <section class="taas-section taas-section--light">
    <div class="taas-container taas-center">
      <span class="taas-pill taas-pill--gold">Capabilities</span>
      <h2>A Modern Ecosystem<br />For Certified Tax Practitioners</h2>

      <div class="capability-list">
        <div
          class="capability-row"
          *ngFor="let capability of capabilities; index as i"
          data-reveal="rise"
          [style.--reveal-delay]="(i * 90) + 'ms'"
        >
          <h3>{{ capability.title }}</h3>
          <p>{{ capability.text }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="taas-section taas-section--dark">
    <div class="taas-container eligibility-grid">
      <div>
        <span class="taas-pill taas-pill--dark">Eligibility</span>
        <h2>Who Can Apply?</h2>
        <p>
          To protect the integrity of tax administration in Anambra State, all
          applicants must meet standard professional, identity, and statutory
          benchmarks before hitting submission.
        </p>
        <button type="button" class="taas-link-button" (click)="startApplication()">
          Start Application
          <span class="material-icons">arrow_forward</span>
        </button>

        <div class="eligibility-preview">
          <img src="/assets/img/taas-eligibility-laptop.svg" alt="Tax practitioner working on a laptop" />
          
        </div>
      </div>

      <div class="requirement-list">
        <div
          class="requirement-card"
          *ngFor="let requirement of requirements; index as i"
          data-reveal="side"
          [style.--reveal-delay]="(i * 110) + 'ms'"
        >
          <span class="material-icons">check_circle</span>
          <div>
            <h3>{{ requirement.title }}</h3>
            <p>{{ requirement.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="taas-section taas-section--light">
    <div class="taas-container taas-center">
      <span class="taas-pill taas-pill--gold">How It Works</span>
      <h2>Your Path To Official<br />Accreditation</h2>

      <div class="process-line" aria-label="TAAS accreditation process">
        <article
          class="process-step"
          *ngFor="let step of steps; index as i"
          data-reveal="pop"
          [style.--reveal-delay]="(i * 100) + 'ms'"
        >
          <span class="process-step__icon">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect width="46" height="46" rx="23" fill="#3C3F64" />
              <path
                [attr.d]="step.iconPath"
                stroke="#FFC50C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <h3>{{ step.title }}</h3>
          <p>{{ step.text }}</p>
        </article>
      </div>

      <section #verificationSection class="verification-panel" data-reveal="rise">
        <h3>Verify A Tax Agent's Status</h3>
        <p>
          Confirm a practitioner's active standing using their TAAS accreditation
          or application number.
        </p>

        <form [formGroup]="verificationForm" (ngSubmit)="verifyAgent()" class="verification-form">
          <div class="verification-input">
            <span class="material-icons">search</span>
            <input
              #taasIdInput
              type="text"
              formControlName="id"
              placeholder="Enter TAAS ID, e.g. TAAS-1960821970"
              autocomplete="off"
            />
          </div>
          <button type="submit" class="taas-button taas-button--gold" [disabled]="isVerifying">
            {{ isVerifying ? "Verifying..." : "Verify" }}
          </button>
        </form>
        <small *ngIf="verificationForm.get('id')?.touched && verificationForm.get('id')?.invalid">
          Enter a TAAS accreditation or application ID to continue.
        </small>
      </section>
    </div>
  </section>

  <section class="sanctions-notice" data-reveal="rise">
    <div class="taas-container">
      <span class="material-icons">warning</span>
      <p>
        <strong>Notice on Sanctions:</strong> Submitting false data, aiding tax
        fraud, or engaging in professional malpractice will trigger automatic
        revocation of credentials, system lockout, and administrative or legal
        sanctions under the service directives.
      </p>
    </div>
  </section>
</main>

<app-footer></app-footer>

<ng-template #verificationModal>
  <div class="taas-modal">
    <button type="button" class="taas-modal__close" aria-label="Close" (click)="closeVerificationModal()">
      <span class="material-icons">close</span>
    </button>

    <ng-container [ngSwitch]="verificationState">
      <div *ngSwitchCase="'found'">
        <div class="taas-modal__status taas-modal__status--valid">
          <span class="material-icons">verified</span>
          <div>
            <h3>Valid TAAS Certificate</h3>
            <p>This tax agent's accreditation record was found.</p>
          </div>
        </div>

        <div class="taas-result-grid">
          <div>
            <span>Assessment ID</span>
            <strong>{{ verificationResult?.assessmentId || "N/A" }}</strong>
          </div>
          <div>
            <span>Application ID</span>
            <strong>{{ verificationResult?.applicationId || "N/A" }}</strong>
          </div>
          <div>
            <span>Full Name</span>
            <strong>{{ verificationResult?.fullName || "N/A" }}</strong>
          </div>
          <div>
            <span>Company Name</span>
            <strong>{{ verificationResult?.companyName || "N/A" }}</strong>
          </div>
          <div>
            <span>Email</span>
            <strong>{{ verificationResult?.email || "N/A" }}</strong>
          </div>
          <div>
            <span>Phone</span>
            <strong>{{ verificationResult?.phone || "N/A" }}</strong>
          </div>
          <div>
            <span>ASIN</span>
            <strong>{{ verificationResult?.asin || "N/A" }}</strong>
          </div>
          <div>
            <span>Status</span>
            <strong class="status-valid">{{ verificationResult?.status || "N/A" }}</strong>
          </div>
          <div>
            <span>Approval Status</span>
            <strong>{{ verificationResult?.approvalStatus || "N/A" }}</strong>
          </div>
          <div>
            <span>Certificate Type</span>
            <strong>{{ verificationResult?.assessmentType || "N/A" }}</strong>
          </div>
          <div>
            <span>Assessment Year</span>
            <strong>{{ verificationResult?.assessmentYear || "N/A" }}</strong>
          </div>
          <div>
            <span>Issued Date</span>
            <strong>{{ verificationResult?.issuedDate ? (verificationResult?.issuedDate | date: "mediumDate") : "N/A" }}</strong>
          </div>
          <div>
            <span>Expiry Date</span>
            <strong>{{ verificationResult?.expiryDate ? (verificationResult?.expiryDate | date: "mediumDate") : "N/A" }}</strong>
          </div>
          <div>
            <span>Date Created</span>
            <strong>{{ verificationResult?.dateCreated ? (verificationResult?.dateCreated | date: "medium") : "N/A" }}</strong>
          </div>
        </div>
      </div>

      <div *ngSwitchCase="'not-found'" class="taas-modal__empty">
        <span class="material-icons">search_off</span>
        <h3>TAAS Record Not Found</h3>
        <p>No active TAAS certificate was found for the ID you entered.</p>
      </div>

      <div *ngSwitchDefault class="taas-modal__empty">
        <span class="material-icons">error_outline</span>
        <h3>Verification Unavailable</h3>
        <p>Unable to verify this agent right now. Please try again shortly.</p>
      </div>
    </ng-container>
  </div>
</ng-template>
